import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "services/common"

import { defaultAxiosInstance } from "./client"

const defaultUrl = `${process.env.REACT_APP_BASE_API_URL || ""}/otp`

export interface VerifyEmailOTPForEditEmailRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    otp: string
  }
}

export interface VerifyEmailOTPForEditEmailResponseData extends ResponseData {
  data: {
    verified: boolean
  }
}

export interface VerifyEmailOTPForEditEmailResponse extends AxiosResponse {
  data: VerifyEmailOTPForEditEmailResponseData
}

// -------- verify email OTP for profile edit email flow ------------
export function verifyEmailOTPForEditEmail(
  {
    params,
    method = "get",
    url = `${defaultUrl}/verify-email-otp`,
    ...config
  }: VerifyEmailOTPForEditEmailRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<VerifyEmailOTPForEditEmailResponse> {
  return axiosInstance({
    params,
    method,
    url,
    ...config,
  }) as Promise<VerifyEmailOTPForEditEmailResponse>
}

export interface ResendEmailOTPForEditEmailResponseData extends ResponseData {
  data: {
    otpSent: boolean
    code: string
  }
}

export interface ResendEmailOTPForEditEmailResponse extends AxiosResponse {
  data: ResendEmailOTPForEditEmailResponseData
}

// -------- Resend email OTP for profile edit email flow ------------
export function resendEmailOTPForEditEmail(
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<ResendEmailOTPForEditEmailResponse> {
  return axiosInstance({
    method: "post",
    url: `${defaultUrl}/request-email-otp`,
  }) as Promise<ResendEmailOTPForEditEmailResponse>
}

export interface VerifyMobileOTPForEditMobileRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    otp: string
  }
}

export interface VerifyMobileOTPForEditMobileResponseData extends ResponseData {
  data: {
    verified: boolean
  }
}

export interface VerifyMobileOTPForEditMobileResponse extends AxiosResponse {
  data: VerifyMobileOTPForEditMobileResponseData
}

// -------- verify mobile OTP for profile edit mobile flow ------------
export function verifyMobileOTPForEditMobile(
  {
    params,
    method = "get",
    url = `${defaultUrl}/verify-mobile-otp`,
    ...config
  }: VerifyMobileOTPForEditMobileRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<VerifyMobileOTPForEditMobileResponse> {
  return axiosInstance({
    params,
    method,
    url,
    ...config,
  }) as Promise<VerifyMobileOTPForEditMobileResponse>
}

export interface ResendMobileOTPForEditMobileResponseData extends ResponseData {
  data: {
    otpSent: boolean
    code: string
    mobileNum: string
    existingUser: true
  }
}

export interface ResendMobileOTPForEditMobileResponse extends AxiosResponse {
  data: ResendMobileOTPForEditMobileResponseData
}

// -------- Resend mobile OTP for profile edit mobile flow ------------
export function resendMobileOTPForEditMobile(
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<ResendMobileOTPForEditMobileResponse> {
  return axiosInstance({
    method: "post",
    url: `${defaultUrl}/request-mobile-otp`,
  }) as Promise<ResendMobileOTPForEditMobileResponse>
}
